module.exports = __webpack_public_path__ + "static/img/pay_more_wechat.77de2618.png";